import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import reloj from '../../../assets/img/reloj-01.svg';

import "./clockHelper.css"

const Clock = props => {
  const { time } = props

  const _parseToSeconds = time => {
    if (time === -1) {
      return 0
    } else if (time < 60) {
      return time
    } else if (time >= 60) {
      return time % 60
    }
  }
  const _parseToMinutes = time => (time < 60 ? 0 : parseInt(time / 60))

  const [seconds, setSeconds] = useState(_parseToSeconds(time))
  const [minutes, setMinutes] = useState(_parseToMinutes(time))

  useEffect(() => {
    setSeconds(_parseToSeconds(time))
    setMinutes(_parseToMinutes(time))
  }, [time])

  const formatTime = time => (time < 10 ? `0${time}` : `${time}`)

  return (
    <>
      <span className="ClockHelper__minutes">{formatTime(minutes)}</span>
      <span className="ClockHelper__seconds">{formatTime(seconds)}</span>
    </>
  )
}

const ClockHelper = props => {
  const {
    mode,
    initialTime,
    finalTime,
    complementaryText,
    loading,
    onChangeIsTimeUp,
    onRetry
  } = props

  const variationByMode = {
    chronometer: 1,
    timer: -1
  }

  const timeVariation = variationByMode[mode] || 1

  const [iterator, setIterator] = useState(null)
  const [time, setTime] = useState(initialTime)
  const [isTimeUp, setIsTimeUp] = useState(false)

  useEffect(() => {
    return () => clearInterval(iterator)
  }, [])

  useEffect(() => {
    if (initialTime > -1) setIterator(_startIterator())
    else if (initialTime === -1) {
      setTime(-1)
      clearInterval(iterator)
    }
  }, [initialTime])

  useEffect(() => {
    if (iterator) setTime(initialTime)
  }, [iterator])

  useEffect(() => {
    if (time === 0 || (finalTime && time === finalTime)) {
      clearInterval(iterator)
      setIsTimeUp(true)
    }
  }, [time])

  useEffect(() => {
    if (isTimeUp) onChangeIsTimeUp(isTimeUp)
  }, [isTimeUp])

  const _startIterator = () => {
    return setInterval(() => {
      setTime(time => time + timeVariation)
    }, 1000)
  }

  const handleClickRetry = () => {
    setIsTimeUp(false)
    setTime(initialTime)
    setIterator(_startIterator())
    onRetry()
  }

  return (
    <section
      className={`ClockHelper${isTimeUp ? " ClockHelper--is-time-up" : ""}${
        loading ? " ClockHelper--loading" : ""
      }`}
    >
      <div
        className={`ClockHelper__label${
          loading ? " ClockHelper--animated-background" : ""
        }`}
      >
        <img src={reloj} alt="clock" alt="imagen-reloj" />
        <div className="ClockHelper__time">
          <Clock time={time} />
        </div>
      </div>
      {complementaryText && (
        <p
          className={`ClockHelper__complementary-text${
            loading ? " ClockHelper--animated-background" : ""
          }`}
        >
          <span>{complementaryText}</span>
          {/* {isTimeUp && (
            <>
              <button
                onClick={handleClickRetry}
                className="ClockHelper__btn-retry"
                type="button"
              >
                Reintentar
              </button>
            </>
          )} */}
        </p>
      )}
    </section>
  )
}

ClockHelper.defaultProps = {
  mode: "chronometer",
  initialTime: 0,
  finalTime: 3600,
  complementaryText: "",
  loading: false,
  onChangeIsTimeUp: () => {},
  onRetry: () => {}
}

ClockHelper.propTypes = {
  mode: PropTypes.string,
  initialTime: PropTypes.number,
  finalTime: PropTypes.number,
  complementaryText: PropTypes.string,
  loading: PropTypes.bool,
  onChangeIsTimeUp: PropTypes.func,
  onRetry: PropTypes.func
}

export default ClockHelper
